import { registerBlock, registerRelationship } from "../../registry";
import { makeId } from "../../helpers";
import type { ContentBlock } from "../../types";

const hisOptimization: ContentBlock<"program"> = {
  id: makeId("program-his-optimization"),
  kind: "program",
  tags: ["optimization", "his", "sperm", "supplements", "lifestyle"],
  title: "His 90-Day Optimization",
  subtitle: "Measurably improve sperm health — real numbers, real progress",
  icon: "🏋️",
  body: {
    duration: "3 months",
    includes: [
      "Baseline semen analysis with detailed morphology",
      "Targeted supplement stack (CoQ10, Zinc, Vitamin D, Omega-3)",
      "Lifestyle protocol (heat avoidance, exercise, sleep, alcohol)",
      "Monthly check-ins with progress tracking",
      "Repeat semen analysis at 90 days",
      "Optional: DNA fragmentation panel",
    ],
    priceRange: { low: 300, high: 600 },
    currency: "USD",
    status: "coming-soon",
    forWhom: "him",
    category: "optimization",
    moduleIds: [
      makeId("module-male-fertility-baseline"),
      makeId("module-male-optimization"),
    ],
    phases: [
      {
        title: "Baseline",
        description: "Semen analysis to know your starting numbers",
        moduleIds: [makeId("module-male-fertility-baseline")],
      },
      {
        title: "Optimize",
        description: "90 days targeting the full sperm cycle",
        moduleIds: [makeId("module-male-optimization")],
      },
    ],
    steps: [
      {
        title: "Baseline SA",
        description:
          "Semen analysis to establish count, motility, and morphology.",
      },
      {
        title: "Begin protocol",
        description:
          "Supplements and lifestyle changes targeting the 74-day sperm development cycle.",
      },
      {
        title: "Retest at 90 days",
        description:
          "Repeat semen analysis to measure improvement in count, motility, and morphology.",
      },
    ],
  },
  sources: [
    {
      title:
        "The effect of antioxidant supplementation on sperm parameters: a systematic review",
      journal: "Reproductive BioMedicine Online",
      year: 2022,
      evidenceLevel: "meta-analysis",
    },
  ],
};

registerBlock(hisOptimization);

registerRelationship({
  from: makeId("program-his-optimization"),
  to: makeId("module-male-fertility-baseline"),
  type: "contains",
});
registerRelationship({
  from: makeId("program-his-optimization"),
  to: makeId("module-male-optimization"),
  type: "contains",
});
